import { getFunctions, httpsCallable } from 'firebase/functions';

export const requireDataset = (requester) => {
  const functions = getFunctions();
  const emailRequireDataSet = httpsCallable(functions, 'emailRequireDataSet');
  emailRequireDataSet(requester).then(function(result) {
    //empty
  });
}